<template>
  <quill-editor
    v-model="content"
    :options="editorOption"
    @ready="onEditorReady"
    @blur="handleBlur"
    @focus="handleFocus"
    @change="handleChange"
  />
</template>

<script>
// 注册图片上传模块
import Quill from "quill";
import { quillEditor } from "vue-quill-editor";
import ImageUploader from "quill-image-uploader";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";

Quill.register("modules/imageUploader", ImageUploader);

const toolbarOptions = [
  ["bold", "italic", "underline", "strike"], // 加粗 斜体 下划线 删除线 -----['bold', 'italic', 'underline', 'strike']
  ["blockquote", "code-block"], // 引用  代码块-----['blockquote', 'code-block']
  [{ list: "ordered" }, { list: "bullet" }], // 有序、无序列表-----[{ list: 'ordered' }, { list: 'bullet' }]
  [{ header: 1 }, { header: 2 }],
  [{ script: "sub" }, { script: "super" }], // 上标/下标-----[{ script: 'sub' }, { script: 'super' }]
  [{ indent: "-1" }, { indent: "+1" }],
  [{ size: ["small", false, "large", "huge"] }], // 配置字号
  [{ header: [1, 2, 3, 4, 5, 6, false] }], // 标题-----[{ header: [1, 2, 3, 4, 5, 6, false] }]
  [{ color: [] }, { background: [] }], // 字体颜色、字体背景颜色-----[{ color: [] }, { background: [] }]
  [{ font: [] }], //显示字体选择
  [{ align: [] }], // 对齐方式-----
  ["clean"], // 清除文本格式-----
  ["link", "image"], // 链接、图片、视频-----
];

export default {
  name: "QuillEditor",
  props: {
    value: {
      type: String,
      default: "",
    },
  },
  components: {
    quillEditor,
  },
  data() {
    return {
      quill:{},
      content: this.value,
      editorOption: {
        modules: {
          toolbar: toolbarOptions,
          imageUploader: {
            upload: (file) => {
              return new Promise((resolve, reject) => {
                const formData = new FormData();
                formData.append("file", file);
                // 调用后端上传接口
                fetch("/api/admin/uploadfile", {
                  method: "POST",
                  body: formData,
                })
                  .then((response) => response.json())
                  .then((result) => {
                    resolve(result.data.url);
                  })
                  .catch((error) => {
                    reject("上传失败");
                  });
              });
            },
          },
        },
      },
    };
  },
  methods: {
    onEditorReady(quill) {
      console.log("编辑器初始化完成", quill);
      this.quill = quill;
      quill.root.innerHTML = this.value;
      this.content = this.value
    },
    handleBlur(quill) {
      console.log('编辑器失去焦点', quill)
      // 执行自动保存逻辑
    },
    handleFocus(quill) {
      console.log('编辑器获得焦点', quill)
    },
    handleChange({ html, text, quill }) {
      this.$emit("changeData",html)
      // 内容校验
    }
  },
  mounted(){

  },
  watch: {
    value(newValue) {
      if (newValue !== this.quill.root.innerHTML) {
        this.quill.root.innerHTML = newValue;
      }
    }
  }
};
</script>
 
<style>
.quill-editor {
  height: 800px; /* 可以根据需要调整高度 */
}
</style>